/** @file Builds a name -> index map over an array of named records (first occurrence wins). */

/** Map from each record's name to its index. */
export function nameIndex(items: readonly { name: string }[]): Map<string, number> {
  const index = new Map<string, number>();
  items.forEach((item, i) => {
    if (!index.has(item.name)) index.set(item.name, i);
  });
  return index;
}
